// Momento Feldenkrais -- JS globale
(function () {
  function init() {
    var h = document.getElementById('mf-header');
    if (h && h.getAttribute('data-overlay') === 'true') {
      window.addEventListener('scroll', function () {
        h.classList.toggle('mf-scrolled', window.scrollY > 60);
      }, { passive: true });
    }
    var t = document.getElementById('mf-toggle');
    var l = document.getElementById('mf-links');
    if (!t || !l) { return; }
    function closeMenu() {
      l.classList.remove('mf-open');
      document.body.classList.remove('mf-menu-open');
    }
    function toggleMenu(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      var willOpen = !l.classList.contains('mf-open');
      l.classList.toggle('mf-open', willOpen);
      document.body.classList.toggle('mf-menu-open', willOpen);
    }
    t.addEventListener('click', toggleMenu);
    // chiudi quando si clicca un link
    var links = l.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', closeMenu);
    }
    // chiudi cliccando fuori dal menu
    document.addEventListener('click', function (e) {
      if (!l.classList.contains('mf-open')) { return; }
      if (l.contains(e.target) || t.contains(e.target)) { return; }
      closeMenu();
    });
    // chiudi con ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeMenu(); }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
